import styled from "styled-components";

import { Colors } from "../../../../../../common";

const Root = styled.div`
	grid-area: points;

	min-height: 134px;

	overflow: hidden;

	background: ${Colors.BACKGROUND_BLUE_1};

	// flex: 1 1 auto;
	min-height: 0;
	overflow: auto;
`;

export default Root;
